import { Injectable } from '@angular/core';
import {
    BaseHttpService,
    UriBuilderParams
} from '@app/core/services/base/base-http.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { Banner } from '@app/shared/models/banner';
import { DRResponse } from '@app/shared/models/response';

export class BannerUriBuilderParams extends UriBuilderParams<Banner> {

    constructor(banner?: Banner | string) {
        super(banner);
    }

    public buildUri(): string {
        let uri = `/${BackendUriUnits.CLIENTS}`;
        uri += this.simpleUriBuild(BackendUriUnits.BANNER);
        return uri;
    }
}

@Injectable({ providedIn: 'root' })
export class BannerService extends BaseHttpService<Banner, BannerUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(Banner, httpServiceBundle, true);
    }

    public getActiveBanner(): Observable<Banner> {
        return this.http.get<DRResponse<Banner>>(`${this.uri}/${BackendUriUnits.CLIENTS}/${BackendUriUnits.BANNER}`)
                        .pipe(map(res => new Banner(res.data)));
    }
}
